import PrivateChatContainer from "../../../../Components/Applications/Chat/PrivateChat/PrivateChatContainer";

const PrivateChat = () => {
  return <PrivateChatContainer />;
};

export default PrivateChat;
